import { type CSSProperties } from 'react';
import styled from 'styled-components';

import { colors } from '@gbs-monorepo-packages/styles';

import { SelectFilter } from '../../link_common_components/SelectFilter';
import { type IClientDTO } from '../../services/companies';

export const ErrorMessage = styled.p`
  font-size: 0.875rem;
  color: ${colors.red300};
  margin: -5px 0px 15px 0px;
`;

const selectFilterContentCustom: CSSProperties = {
  maxHeight: '90vh',
  position: 'absolute',
  left: '12px',
};

export const SelectFilterCustom = styled(SelectFilter<IClientDTO>).attrs(
  ({ customContentStyle = selectFilterContentCustom }) => ({
    customContentStyle,
  })
)``;
